/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_How_TailInputs */

const en_price_page_how_tail = /** @type {(inputs: Price_Page_How_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`with no surprises.`)
};

const pl_price_page_how_tail = /** @type {(inputs: Price_Page_How_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bez niespodzianek.`)
};

/**
* | output |
* | --- |
* | "with no surprises." |
*
* @param {Price_Page_How_TailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_how_tail = /** @type {((inputs?: Price_Page_How_TailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_How_TailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_how_tail(inputs)
	return en_price_page_how_tail(inputs)
});